import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface Props {
  className?: string;
  children: ReactNode;
}

const BodyBox = ({ className, children }: Props) => {
  return (
    <>
      <div
        className={twMerge(
          `mx-auto px-[20px] max-w-[1360px] ${className}`
        )}
      >
        {children}
      </div>
    </>
  );
};

export default BodyBox;
